<template>
  <div class="draft-app-icon">
    <header class="draft-app-icon__name">
      {{ $t('APPS.DRAFT.STEPS.APP_MEDIA.APP_ICON') }}
    </header>

    <img
      class="draft-app-icon__icon"
      :src="draftApp.icon"
      :alt="draftApp.name"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { DRAFT_APP } from '@/store/types';

export default {
  name: 'DraftAppIcon',
  computed: {
    ...mapGetters({ draftApp: DRAFT_APP }),
  },
};
</script>

<style lang="scss">
.draft-app-icon {
  margin-bottom: $global-margin;

  &__icon {
    width: 50px;
    height: 50px;
  }

  &__name {
    font-size: 110%;
    font-weight: 500;
    margin-bottom: $global-margin/2;
  }
}
</style>
